import { render, staticRenderFns } from "./SH062ShopperMatomeItemInfo.vue?vue&type=template&id=78d9bc69&"
import script from "./SH062ShopperMatomeItemInfo.vue?vue&type=script&lang=js&"
export * from "./SH062ShopperMatomeItemInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports